module.exports = __webpack_public_path__ + "static/osteopathie-behandlung-2cac6a9a0868f7f6d85712941464f58c.jpg";